import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Stethoscope, Sparkles, Activity, ShieldPlus, Baby, HeartPulse } from 'lucide-react';
const services = [{
  icon: Stethoscope,
  title: 'General Checkups',
  description: 'Comprehensive exams, gentle cleanings, and preventative care to keep your smile healthy year-round.'
}, {
  icon: Sparkles,
  title: 'Teeth Whitening',
  description: 'Professional, safe whitening treatments that brighten your smile by several shades in just one visit.'
}, {
  icon: Activity,
  title: 'Invisalign & Ortho',
  description: 'Clear aligners and modern orthodontic solutions for a straighter smile without traditional metal braces.'
}, {
  icon: ShieldPlus,
  title: 'Dental Implants',
  description: 'Permanent, natural-looking tooth replacements that restore full function and confidence.'
}, {
  icon: Baby,
  title: 'Pediatric Dentistry',
  description: 'Fun, fear-free visits for children, establishing healthy habits and positive associations early on.'
}, {
  icon: HeartPulse,
  title: 'Emergency Care',
  description: 'Prompt, compassionate relief for toothaches, broken teeth, and other urgent dental issues.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function Services() {
  return <section id="services" className="py-24 bg-white" data-id="element-167">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-168">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-169">
          <h2 className="text-sage font-semibold tracking-wider uppercase text-sm mb-3" data-id="element-170">
            Our Services
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-charcoal-800 mb-6" data-id="element-171">
            Comprehensive care for your best smile.
          </h3>
          <p className="text-lg text-charcoal-500" data-id="element-172">
            From routine maintenance to complete smile makeovers, we offer a
            full spectrum of modern dental treatments under one roof.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-173">
          {services.map((service, index) => <motion.div key={index} variants={itemVariants} className="group bg-cream p-8 rounded-3xl transition-all duration-300 hover:shadow-soft hover:-translate-y-1 border border-transparent hover:border-sage-100" data-id="element-174">
              <div className="w-14 h-14 bg-white rounded-2xl flex items-center justify-center text-sage mb-6 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-175">
                <service.icon size={28} strokeWidth={1.5} data-id="element-176" />
              </div>
              <h4 className="text-xl font-serif font-medium text-charcoal-800 mb-3" data-id="element-177">
                {service.title}
              </h4>
              <p className="text-charcoal-500 leading-relaxed" data-id="element-178">
                {service.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}